import React, { useState } from "react";
import { useCart } from "react-use-cart";
// Removed unused firebase imports
import CheckoutForm from "./CheckoutForm";
import Shop from "./Shop";
import { formatPrice } from "../utils/priceFormatter";

const Cart = ({title, theme, setTheme}) => {
  const {
    isEmpty,
    items,
    cartTotal,
    totalItems,
    updateItemQuantity,
    removeItem,
    emptyCart,
  } = useCart();

  // Removed unused productQuantities state

  // Debug logging
  console.log('Cart state:', { isEmpty, items, cartTotal, totalItems });

  // Helper function to safely get product image
  const getProductImage = (item) => {
    if (item.product_media && Array.isArray(item.product_media) && item.product_media.length > 0) {
      return item.product_media[0];
    }
    if (item.product_image && Array.isArray(item.product_image) && item.product_image.length > 0) {
      return item.product_image[0];
    }
    if (item.product_image && typeof item.product_image === 'string') {
      return item.product_image;
    }
    // Return a placeholder image if no image is available
    return "https://via.placeholder.com/150x150?text=No+Image";
  };

  // Helper function to safely get product name
  const getProductName = (item) => {
    return item.product_name || item.title || item.name || "Unknown Product";
  };

  // Helper function to safely get product price
  const getProductPrice = (item) => {
    return item.price || item.cost || 0;
  };

  // const handlePaymentSuccess = (response, userData) => {
  //   console.log("Payment successful:", response);

  //   const payeeName = userData.name;
  //   const payeeLocation = userData.location;
  //   const payeeEmail = userData.email;
  //   const payeePostalCode = userData.postalCode;
  //   const payeePhoneNumber = userData.phoneNumber;

  //   const productsInCart = items.map((item) => ({
  //     id: item.id,
  //     name: getProductName(item),
  //     quantity: productQuantities[item.id] || item.quantity,
  //   }));

  //   const data = {
  //     amount: cartTotal,
  //     createdAt: new Date(),
  //     productPaidFor: items.map((item) => getProductName(item)).join(", "),
  //     product_image: items.map((item) => getProductImage(item)).join(", "),
  //     quantity: items.reduce((total, item) => total + item.quantity, 0),
  //     payeeName,
  //     payeeLocation,
  //     payeeEmail,
  //     payeePostalCode,
  //     payeePhoneNumber,
  //     productsInCart,
  //     status: 'Successful'

  //   };

  //   firestore
  //     .collection("Users")
  //     .doc(firebase.auth().currentUser.uid)
  //     .collection("Payments")
  //     .add(data)
  //     .then((docRef) => {
  //       console.log("Payment data saved with ID:", docRef.id);
  //     })
  //     .catch((error) => {
  //       console.error("Error saving payment data:", error);
  //     });

  //     // navigate()

      
  //   };
    
  //   // const navigate = <Link to={'/order'} />

  // const handlePaymentClose = () => {
  //   console.log("Payment cancelled");
  // };


  // const handleOrderAttempts = (response, userData) => {
  //   const payeeName = userData.name;
  //   const payeeLocation = userData.location;
  //   const payeeEmail = userData.email;
  //   const payeePostalCode = userData.postalCode;
  //   const payeePhoneNumber = userData.phoneNumber;

  //   const productsInCart = items.map((item) => ({
  //     id: item.id,
  //     name: getProductName(item),
  //     quantity: productQuantities[item.id] || item.quantity,
  //   }));

  //   const data = {
  //     amount: cartTotal,
  //     createdAt: new Date(),
  //     productPaidFor: items.map((item) => getProductName(item)).join(", "),
  //     product_image: items.map((item) => getProductImage(item)).join(", "),
  //     quantity: items.reduce((total, item) => total + item.quantity, 0),
  //     payeeName,
  //     payeeLocation,
  //     payeeEmail,
  //     payeePostalCode,
  //     payeePhoneNumber,
  //     productsInCart,
  //     status: 'Attempt'
  //   };
  //   firestore
  //   .collection("Users")
  //   .doc(firebase.auth().currentUser.uid)
  //   .collection("OrderAttempt")
  //   .add(data)
  //   .then((docRef) => {
  //     console.log("Payment data saved with ID:", docRef.id);
  //   })
  //   .catch((error) => {
  //     console.error("Error saving payment data:", error);
  //   }); 
  //  };

   const [Show, setShow] = useState(false)

  // Removed Stripe configuration - now using Flutterwave
  

  return (
    <>
    {/* {
      Show ?
      <Link 
      onClick={() => setShow(!Show)}
      // to="/cart"
       className="mr-4">
      <BiShoppingBag
        // size="30"
        className="h-6 w-6"
        color={title === "me" ? "#fff" : "#555"}
        // className="rounded-full shadow-2xl drop-shadow-2xl shadow-gray-700 "
      />
      {!isEmpty && (
        <span className=" absolute top-2 ml-4 font-bold text-lg text-white rounded-full w-7 text-center bg-orange-600">
          {totalItems}
        </span>
      )}
    </Link>
    : */}
    <div 
        // style={{backgroundImage: `url(${Son})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}
    className="w-[100%] pt-5 px-0 grid justify-center bg-white dark:bg-gradient-to-r from-black to-amber-900 min-h-screen">

{/* <Link
            className=" z-50 absolute top-5 right-5"
            onClick={() => setShow(!Show)}
          >

              <AiOutlineClose className="h-5 w-5 z-50" color="#000" />

          </Link> */}

    {/* className="w-screen grid justify-center text-center pt-10 lg:pt-16 bg-[#656564]"> */}
      {/* <h1 className="text-gray-700 text-lg text-start mt-5">
        Your order
        </h1> */}
      <h1 className="text-gray-700 dark:text-white mt-20 text-2xl">{isEmpty ? "Your Cart is Empty" : ""}</h1>
        <h1 className="text-gray-700 dark:text-white text-2xl px-10 text-start mb-5">
          Shopping Cart
        </h1>
        
      <div className="justify-content-center">
        <div
          responsive="sm"
          striped
          bordered
          hover
          className="mb-0 rounded-md p-2"
        >
          <tbody className="grid justify-center">
            {items && items.length > 0 ? items.map((item, index) => {
              // Validate item data
              if (!item || !item.id) {
                console.error('Invalid item in cart:', item);
                return null;
              }
              
              return (
                <tr
                  key={index}
                  className="lg:flex p-4 px-10 w-80 md:w-fit bg-white dark:bg-amber-900/20 rounded-2xl mb-14 justify-center items-center text-center grid grid-cols-1 border border-amber-200 dark:border-amber-700 shadow-sm dark:shadow-amber-700/30"
                >
                  <td className=" grid justify-center">
                    <div
                      className="rounded-lg ml- md:flex flex-col text-center justify-center mb-0 drop-shadow-2xl shadow-2xl bg-white dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700"
                      style={{
                        height: "10rem",
                        overflow: "hidden",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                        <img
                          src={getProductImage(item)}
                          className="w-40 p-0 md:ml-0 text-center hover:scale-110 duration-500"
                          alt={getProductName(item)}
                          onError={(e) => {
                            e.target.src = "https://via.placeholder.com/150x150?text=No+Image";
                          }}
                        />
                    </div>
                  </td>
                  <td>
                    <h6 className="md:pl-10 text-center w-80 justify-center grid mt-8 pr-10 font-bold text-gray-800 dark:text-white">
                      {getProductName(item)}
                  <td className="text-green-500 dark:text-amber-400 -10">{formatPrice(getProductPrice(item))}</td>
                    </h6>
                  </td>

                  <td className="">
                    <div className="flex text-center justify-center">
                    <button
                      onClick={() =>
                        updateItemQuantity(item.id, item.quantity - 1)
                      }
                      className="text-3xl m-4 p-2 w-14 bg-white dark:bg-amber-900/20 rounded-full drop-shadow-2xl shadow-2xl hover:bg-amber-600 hover:text-white dark:hover:bg-amber-700 duration-500 text-amber-600 dark:text-amber-300 border border-amber-200 dark:border-amber-700"
                      >
                      -
                    </button>
                      <button className="text-gray-600 dark:text-amber-200 p-2 w-14 duration-500 m-4 text-2xl rounded-full bg-white dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700">{item.quantity}</button>
                    <button
                      onClick={() =>
                        updateItemQuantity(item.id, item.quantity + 1)
                      }
                      className="text-3xl m-4 p-2 w-14 bg-white dark:bg-amber-900/20 rounded-full drop-shadow-2xl shadow-2xl hover:bg-amber-600 hover:text-white dark:hover:bg-amber-700 duration-500 text-amber-600 dark:text-amber-300 border border-amber-200 dark:border-amber-700"
                      >
                      +
                    </button>{" "}
                      </div>
                      {/* <div className="flex items-center justify-center">
                    <button
                      onClick={() =>
                        updateItemQuantity(item.id, item.quantity - 1)
                      }
                      className="text-4xl p-5 m-4 bg-white rounded-full duration-500 drop-shadow-2xl shadow-2xl hover:bg-red-600 hover:text-white w-20 text-red-600"
                    >
                      -
                    </button>
                    <p className="w-20 bg-white shadow-2xl drop-shadow-2xl rounded-full p-5">
                      {item.quantity}
                      </p>
                    <button
                      onClick={() =>
                        updateItemQuantity(item.id, item.quantity + 1)
                      }
                      className="text-4xl m-4 p-5 w-20 bg-white rounded-full drop-shadow-2xl shadow-2xl hover:bg-green-600 hover:text-white duration-500  text-green-600"
                    >
                      +
                    </button>
                  </div> */}
                    <br className="md:hidden" />
                    <button
                      variant="danger"
                      onClick={() => removeItem(item.id)}
                      className="m-2 text-red-600 dark:text-red-400 bg-white dark:bg-amber-900/20 rounded-lg hover:text-white hover:bg-red-600 dark:hover:bg-red-700 duration-700 p-2 px-5 border border-red-200 dark:border-red-700"
                    >
                      Remove Item
                    </button>
                  </td>
                </tr>
              );
            }) : (
              <tr>
                <td colSpan="4" className="text-center py-8 text-gray-500 dark:text-amber-200">
                  No items in cart
                </td>
              </tr>
            )}
          </tbody>
        </div>

        {!isEmpty && (
          <div
            // style={{ }}
            className="bg-light-black text-light mb-0"
          >
            <h2 className="py-2 text-2xl text-gray-700 dark:text-white ml-8 text-center font-bold">
              Total Price: {formatPrice(cartTotal)}
            </h2>
            
            <div className="p-2 flex justify-center" md={4}>
              {/* <button
                variant="danger"
                className="m-2 text-red-600 font-bold text-center border-2 border-red-500 p-1 hover:bg-red-500 hover:text-white duration-500 rounded-lg"
                onClick={() => emptyCart()}
              >
                <MdOutlineShoppingCart size="1.7rem" className="ml-8" />
                Clear Cart
              </button> */}
                 <div
                variant="danger"
                className="my-4 flex font-semibold cursor-pointe w-[95%] ml-2.5 self-center text-center justify-center items-center hover:text-white hover:bg-red-600 dark:hover:bg-red-700 cursor-pointer drop-shadow-2xl shadow-2xl py-3 px-6 bg-gray-50 dark:bg-amber-900/20 text-black dark:text-red-400 duration-500 rounded-full border border-red-200 dark:border-red-700"
                onClick={() => emptyCart()}
              >
                {/* <MdOutlineShoppingCart size="1.7rem" className="mr-2" />  */}
                 Clear Cart
              </div>

              <br />

              {/* <button
                variant="success"
              >
                <PaystackForm

                  amount={cartTotal} // Use the cart total as the payment amount
                  email={firebase?.auth()?.currentUser?.email} // Replace with the customer's email
                  onSuccess={handlePaymentSuccess}
                  onClose={handlePaymentClose}
                  handleOrderAttempts={handleOrderAttempts}
                />
              </button> */}

</div>

<div className="p-2 flex justify-center" md={4}>

{
  Show ?
  <>
          <span id="pay"></span>
  <div className="m-5">
          <CheckoutForm 
            amount={cartTotal}
            items={items}
            customer={{
              name: '',
              email: '',
              phone_number: ''
            }}
            onSuccess={(response) => {
              console.log('Payment successful:', response);
              setShow(false);
              emptyCart(); // Clear cart after successful payment
            }}
            onClose={() => setShow(false)}
          />
  </div>
  </>
  :    
  <>
     {/* <button
   onClick={() => {
     window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
   }}  
   className="my-4 flex text-sm cursor-pointer z-50 self-center lg:relative fixed bottom-0 w-[95%] lg:w-80 lg:bottom-0 text-center justify-center items-center hover:text-white hover:bg-amber-700 drop-shadow-2xl shadow-2xl py-4 px-6 bg-amber-600 dark:bg-amber-700 text-white duration-500 rounded-full"
   // className="bg-dark-primary mt-2 mb-2 p-1 rounded-2xl bg-white  hover:bg-green-600 hover:text-white duration-500  text-green-600"
   style={{ borderRadius: "20", border: 0 }}
   >
             Pay {formatPrice(cartTotal)} With ₦ Naira
           </button> */}
   <button
   onClick={() => setShow(!Show)}
   className="my-4 flex text-sm cursor-pointer z-50 self-center lg:relative fixed bottom-0 w-[95%] lg:w-80 lg:bottom-0 text-center justify-center items-center hover:text-white hover:bg-amber-700 drop-shadow-2xl shadow-2xl py-4 px-6 bg-amber-600 dark:bg-amber-700 text-white duration-500 rounded-full"
   // className="bg-dark-primary mt-2 mb-2 p-1 rounded-2xl bg-white  hover:bg-green-600 hover:text-white duration-500  text-green-600"
   style={{ borderRadius: "20", border: 0 }}
           >
             Pay {formatPrice(cartTotal)} With Flutterwave
           </button>
    </>
}
          </div>
          </div>
        )}

{/* <div className=" mt-[20%]  w-full justify-center items-center">
            <h1 className=" text-center text-xl md:font-bold font-bold mb-6 mt-2 text-white">
              &copy; Nextberries 2023. All rights reserved <Link className='hover:text-blue-500' to={'/policy'}>Privacy Policy</Link>.
            </h1>
          </div> */}
      </div>
      {/* <Nav />
      <MobileNav  title={"me"} /> */}
         {/* <div className="bg-gray-900">
          <Homes />
        </div> */}
        <Shop title={"me"} />
    </div>
    {/* } */}
    </>
  );
};

export default Cart;
